import React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const features = ["Personalized travel blueprints tailored to your unique lifestyle", "Exclusive access to private LGBTQ+ friendly estates and villas", "Personalized travel planning and booking assistance. Contact our team for help planning your journey.", "Curated local experiences led by community insiders and experts", "Seamless logistics management from private jets to luxury transfers"];
export default function BespokeConcierge() {
  return <section data-section-id="260690" id="bespoke-concierge" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className="order-2 lg:order-1 flex flex-col">
            <h2 className="text-3xl md:text-5xl font-default font-medium text-foreground mb-6 leading-tight tracking-tight">
              Bespoke Concierge
            </h2>

            <div className="space-y-4 text-muted-foreground mb-8">
              <p className="leading-relaxed text-lg font-sans">
                Experience travel redefined through our ultra-luxury, one-on-one planning service. We specialize in crafting highly personalized itineraries that reflect your individual tastes, ensuring every moment of your journey is as unique as you are.
              </p>
              <p className="leading-relaxed text-lg font-sans">
                From securing the most coveted tables at world-renowned restaurants to arranging private viewings at exclusive galleries, our agents handle every detail with impeccable precision and discretion.
              </p>
              <p className="leading-relaxed text-lg font-sans">
                Our global network of premium partners allows us to offer unparalleled access and insider knowledge, transforming a simple trip into a sophisticated, life-enriching adventure curated specifically for the premium LGBTQ+ community.
              </p>
            </div>

            <ul className="space-y-3 mb-8">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <div className="bg-primary/10 text-primary rounded-md p-1 mt-0.5 shrink-0">
                    <Check className="size-4" />
                  </div>
                  <span className="text-foreground/90 text-sm md:text-base font-sans">
                    {feature}
                  </span>
                </li>)}
            </ul>

            <div>
              <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground font-default font-semibold tracking-widest uppercase rounded-md shadow-md hover:shadow-lg transition-all">
                <Link to="/ContactUsPage">Connect with an Agent</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2">
            <div className="relative rounded-lg overflow-hidden shadow-xl border border-border/30">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/luxury_lgbtq_travel_concierge.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/luxury_lgbtq_travel_concierge.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/luxury_lgbtq_travel_concierge.png-wvc-sizes" alt="High-fashion luxury travel setting with premium aesthetic" className="w-full h-auto object-cover aspect-[4/3] lg:aspect-auto lg:min-h-[600px]" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}